import React, { useState } from 'react';
import { MetricChart, metricName, metricUnit } from './WorkersWorkspace.jsx';
import { formatUsageQuantity, isSummaryUsage, metricSeries, resourceTotals, usageCoverageText } from './workers-usage.js';

export default function WorkersUsagePanel({ usage, t }) {
  const [selected, select] = useState('');
  const summaries = isSummaryUsage(usage);
  const totals = summaries ? new Map(usage.data.totals.map((row) => [row.metric, row.quantity]))
    : resourceTotals(usage?.data?.buckets || []);
  const metrics = [...totals.keys()];
  const metric = totals.has(selected) ? selected : metrics[0];
  const points = metricSeries(usage?.data?.buckets || [], metric);
  const sources = [...new Set((usage?.data?.buckets || []).flatMap((bucket) => bucket.summaries || [])
    .filter((row) => row.metric === metric).map((row) => row.sourceSelection.kind))];
  const names = { EVENT_SUM: 'Observed calls', CUMULATIVE_LATEST: 'Latest provider measurement', UNRESOLVED: 'Source unresolved' };
  return (
    <section className="ww-usage" aria-label="Observed usage">
      <h3>{t('wk.r.usage')}</h3>
      <p className="ww-muted" role="status">
        {usageCoverageText(usage)}
      </p>
      {summaries && <p className="ww-muted mono">{usage.data.from} — {usage.data.to} · Snapshot {usage.snapshotTime}</p>}
      {metrics.length ? <dl className="ww-res-facts">
        {metrics.map((name) => <div key={name}>
          <dt>{metricName(t, name)}</dt>
          <dd className="mono">{summaries && totals.get(name) === null && !(usage.data.buckets.some((bucket) => bucket.summaries.some((row) => row.metric === name))) ? 'No data' : formatUsageQuantity(totals.get(name))}{totals.get(name) !== null && metricUnit(name) ? ` ${metricUnit(name)}` : ''}</dd>
        </div>)}
      </dl> : <p className="ww-muted">{summaries ? 'No observed usage in this window' : 'Usage unknown'}</p>}
      {metrics.length > 1 && <select className="input" aria-label="Usage metric" value={metric} onChange={(event) => select(event.target.value)}>
        {metrics.map((name) => <option key={name} value={name}>{metricName(t, name)}</option>)}
      </select>}
      {sources.length > 0 && <p className="ww-muted">{sources.map((kind) => names[kind] || 'Source unresolved').join(' · ')}</p>}
      {metric && <MetricChart t={t} title={metricName(t, metric)} points={points} unit={metricUnit(metric)} />}
    </section>
  );
}
